// extracted by mini-css-extract-plugin
module.exports = {"upload_container":"BulkCreateTransferOrderFeature_upload_container__1MPMe"};